import noop from 'lodash/noop';

/*
  if shouldPerformAction function returns true then action performs otherwise not
*/
function createActionByConditionFactory({ shouldPerformAction = () => true, beforeAction = noop, afterAction = noop, onError = noop }) {
  return (action) =>
    (...args) =>
    async (dispatch, getState) => {
      if (!shouldPerformAction(getState, ...args)) {
        return;
      }

      const nextParams = [dispatch, getState, ...args];

      beforeAction(...nextParams);

      try {
        const result = await dispatch(action(...args));

        afterAction(...nextParams);

        // eslint-disable-next-line consistent-return
        return result;
      } catch (e) {
        onError(...nextParams);

        Logger.error('Something went wrong in "actionByConditionFactory"', e);

        throw e;
      }
    };
}

export default createActionByConditionFactory;
